import { api } from "./client";

export interface OpticSummary {
  id: string;
  ref: string | null;
  received_at: string;
  captured_at: string | null;
  debug: boolean;
  hidden: boolean;
  cryodeck_bottle_issued_id: number | null;
  has_dump: boolean;
  pathogen_ids: number[];
}

export interface SampleSet {
  id: number;
  pathogen_id: number | null;
  pathogen_name: string | null;
  control_positive: (number | null)[];
  control_ntc: (number | null)[];
  wells: (number | null)[][];
}

export interface OpticDetail {
  id: string;
  device_id: string;
  ref: string | null;
  received_at: string;
  captured_at: string | null;
  debug: boolean;
  hidden: boolean;
  cryodeck_bottle_issued_id: number | null;
  user_data: Record<string, unknown>;
  sample_sets: SampleSet[];
  has_dump: boolean;
}

export interface OpticDump {
  id: string;
  received_at: string;
  captured_at: string | null;
  baseline: (number | null)[];
  cycles: (number | null)[][];
}

export interface Pathogen {
  id: number;
  name: string;
  type: string;
  unit: string;
}

export const qpcrApi = {
  listForDevice: (deviceId: string, limit = 25) =>
    api.get<{ optics: OpticSummary[] }>(
      `/api/dashboard/devices/${deviceId}/optics?limit=${limit}`,
    ),
  detail: (opticId: string) =>
    api.get<OpticDetail>(`/api/dashboard/optics/${opticId}`),
  dump: (opticId: string) =>
    api.get<OpticDump>(`/api/dashboard/optics/${opticId}/dump`),
  pathogens: () =>
    api.get<{ pathogens: Pathogen[] }>("/api/dashboard/pathogens"),
};
